import React, { useEffect, useState } from "react";
import styles from "../../assets/css/admin/layout.module.css";
import "../../assets/css/admin/allAdmins.module.css"
import SideBar from "./SideBar";
import axios from "axios";
import { baseUrl } from "../../baseUrl";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import {useAuth} from "../../AuthContext"
import { useSidebar } from "../../context/SidebarContext";
import api from "../../api";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const AllAdmins = () => {
  const { logout,user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  useEffect(() => {
    const fetchProtectedData = async () => {
      try {
        const { data } = await api.get('/admin/protected');
      } catch (error) {
        // logout()
        console.error('Error fetching protected data:', error);
      }
    };
    fetchProtectedData();
  }, []);
  const [admins,setAdmins]=useState([])

  const getAdmins=()=>{
    api.get(`${baseUrl}/admin/all`)
    .then(res=>setAdmins(res.data))
    .catch(e=>console.log(e))
  }
  useEffect(()=>{
    getAdmins()
  },[])


  const deleteAdmin=(a)=>{
    swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          api.post(`${baseUrl}/admin/delete/?id=${a._id}`)
            .then(res=>{
              getAdmins()
                swal("Admin has been deleted!", {
                    icon: "success",
                  });
                }
            )
            .catch(err => {
              console.error(err);

              swal("Error deleting admin", {
                text: err.response?.data?.message || "Something went wrong",
                icon: "error",
              });
            });
          
        } 
      });
}

  return (
    <div  className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
    <aside
      className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}
    >
      <SideBar />
    </aside>

      <main className={styles.mainContent}>
      <div style={{height:'30px'}} className="position-relative">{isSidebarOpen?<CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar}/>:<MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar}/>}</div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <div className="flex-grow-1 d-flex">
            <li className="breadcrumb-item">
              <Link to="/admin/dashboard" className="text-decoration-none">
                Dashboard
              </Link>
            </li>
            <li className="breadcrumb-item active">All Admins</li>
            </div>
            <li className="nav-item dropdown">
            <span
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              href=""
              role="button"
              aria-expanded="false"
            >
              Welcome, {user.name}
              <i className="ml-2 fa fa-angle-down"></i>
            </span>
            <ul className="dropdown-menu" style={{minWidth:'150px'}}>
              <li>
                <span className="dropdown-item" onClick={logout}>
                  Logout
                </span>
              </li>
            </ul>
          </li>
          </ol>
        </nav>
        <div
          className="container-fluid"
          style={{ backgroundColor: "white", padding: "40px" }}
        >
          <h4 className="mb-4"> Admins</h4>
          <div style={{overflowX:'scroll'}}>
            <table>
              <thead>
                <tr>
                  <td>SI</td>
                  <td>Name</td>
                  <td>Email</td>
                  <td>Role</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                {admins.length > 0 &&
                  admins.map((a, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{a.name}</td>
                      <td>{a.email}</td>
                      <td>{a.role}</td>
                      <td className="d-flex">
                        <Link to={`/admin/edit/${a._id}`}>
                          <button className="btn btn-success btn-sm p-1">Edit</button>
                        </Link>
                        &nbsp;
                        <button
                          onClick={() => deleteAdmin(a)}
                          className="btn btn-danger btn-sm p-1"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AllAdmins;
